import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

import * as styles from './RequestAccess.module.scss'
import { SUBSCRIBE_NEWSLETTER } from '../../constants/facebookPixel'
import { facebookPixelCustomEvent } from '../../services/facebook-pixel'
import Container from '../container/Container'
import SendEmailForm from '../custom/send-email-form/SendEmailForm'

const SUBSCRIBE_ENDPOINT = `${process.env.GATSBY_BASE_URL}/subscribe`

function RequestAccess({ className }) {
  const [submitedState, setSubmitedState] = useState(false)

  const handleSuccesfullSubscribe = () => {
    setSubmitedState(true)

    facebookPixelCustomEvent(SUBSCRIBE_NEWSLETTER)
  }

  return (
    <section className={classNames(styles.section, className)}>
      <Container fluid>
        {submitedState ? (
          <p className={styles.message}>
            Welcome. Now you'll never miss out on the good stuff.
          </p>
        ) : (
          <>
            <h2 className={styles.title}>
              The latest crypto news delivered {'\n'}straight to your inbox.
            </h2>
            <p className={styles.subheading}>Subscribe to our newsletter</p>
            <SendEmailForm
              id="Newsletter_form"
              className={styles.form}
              URL={SUBSCRIBE_ENDPOINT}
              buttonContent="Sign me up"
              inputId="early_access_email"
              label="email"
              onUserSuccesfullySubmited={handleSuccesfullSubscribe}
            />
          </>
        )}
      </Container>
    </section>
  )
}

RequestAccess.propTypes = {
  className: PropTypes.string,
}

export default React.memo(RequestAccess)
